<template>
  <v-app>
    <!-- Navigation Sidebar -->
    <app-sidebar v-if="!isAuthPage"></app-sidebar>

    <!-- Main Header -->
    <app-header></app-header>

    <v-content>
      <v-container fluid class="px-5 py-5">
        <router-view></router-view>
        <v-snackbar v-if="showSnackbar"
          top right
          :vertical="snackbarConfig.vertical"
          :value="showSnackbar"
          :color="snackbarConfig.color" dark
          :timeout="snackbarConfig.timeout">
          {{ snackbarConfig.message }}
          <v-btn dark text @click="closeSnackbar">Close</v-btn>
        </v-snackbar>
        <v-dialog v-model="popups.manageIssue.dialog" max-width="720" persistent>
          <v-card>
            <v-card-title>Issue</v-card-title>
            <v-card-text>
              <issue-form v-if="popups.manageIssue.dialog"
                :form-data="popups.manageIssue.formData"
                :extraData="popups.manageIssue.extraData"
                @save="onSaveIssue"
                @close="onCancelIssue"></issue-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>

    <!-- Main Footer -->
    <v-footer app height="60" inset>
      <v-spacer></v-spacer>
      <div class="caption px-1">{{ appTitle }} by Masoom S</div>
      <v-spacer v-if="isAuthPage"></v-spacer>
    </v-footer>
  </v-app>
</template>

<style>
.v-application--wrap {
  background: #E8EAED;
}
thead {
  white-space: nowrap;
}
a[href] {
  text-decoration: none;
}
.no-wrap {
  white-space: nowrap;
}
.cursor-edit {
  cursor: text;
}
.ql-snow .ql-toolbar button svg, .quillWrapper .ql-snow.ql-toolbar button svg {
  width: 16px;
  height: 16px;
}
.quillWrapper .ql-snow.ql-toolbar .ql-formats {
  margin-bottom: 2px;
}
.jsoneditor {
  border-color: #d7d7d7;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #bbb;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
.no--scrollbar::-webkit-scrollbar,
.no--scrollbar ::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE and Edge */
.no--scrollbar,
.no--scrollbar .v-navigation-drawer__content {
  -ms-overflow-style: none;
}
</style>

<script>
import { mapState, mapMutations } from 'vuex';
import { GlobalEvents } from './event-bus';
import types, { BUS } from '@/store/types';

import AppHeader from '@/components/AppHeader.vue';
import AppSidebar from '@/components/AppSidebar.vue';
import IssueForm from '@/modules/issues/IssueForm.vue';

export default {
  name: 'App',

  components: {
    AppHeader,
    AppSidebar,
    IssueForm,
  },

  data: () => ({
    // Global Popups
    popups: {
      manageIssue: {
        dialog: false,
        formData: undefined,
        extraData: undefined,
      },
    },
  }),

  computed: {
    ...mapState(['appTitle', 'isAuthPage', 'showSnackbar', 'snackbarConfig']),
  },

  watch: {
    $route() {
      this.$store.dispatch('onRouteChange', this.$route);
    },
  },

  methods: {
    ...mapMutations({
      closeSnackbar: types.CLOSE_SNACKBAR,
    }),
    onSaveIssue(payload) {
      // console.log('emit: save issue', payload);
      this.$root.$emit('taskAdded', payload);
      this.onCancelIssue();
    },
    onCancelIssue() {
      // console.log('emit: cancel issue');
      GlobalEvents.$emit(BUS.CLOSE_MANAGE_ISSUE);
    },
  },

  created() {
    GlobalEvents.$on(BUS.OPEN_MANAGE_ISSUE, (payload) => {
      // console.log('manage issue', payload);
      const { formData, extraData } = payload;
      this.popups.manageIssue.dialog = true;
      this.popups.manageIssue.formData = formData ? {
        ...formData,
      } : undefined;
      if (extraData) {
        this.popups.manageIssue.extraData = {
          ...extraData,
        };
      }
    });
    GlobalEvents.$on(BUS.CLOSE_MANAGE_ISSUE, () => {
      this.popups.manageIssue.dialog = false;
      this.popups.manageIssue.formData = undefined;
      this.popups.manageIssue.extraData = undefined;
    });
  },

  beforeDestroy() {
    GlobalEvents.$off(BUS.OPEN_MANAGE_ISSUE);
    GlobalEvents.$off(BUS.CLOSE_MANAGE_ISSUE);
  },
};
</script>
